var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassesDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 126,
    viewBox: "0 0 156 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.79759,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 11.7607 120.933)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.79759,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 9.52478 116.549)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.79759,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 7.56323 41.0945)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.79759,
    height: 18.7314,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 33.6899 24.1348)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.79759,
    height: 18.7314,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 38.9165 28.4397)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.79759,
    height: 18.7314,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 43.4279 36.3721)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 144.016,
    height: 84.8212,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 5.20947 113.516)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 130.921,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 12.9792 122.302)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.47655,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 141.941 116.628)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 5.47655,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 140.718 38.1594)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 131.7,
    height: 14.088,
    transform: "matrix(1 -8.72146e-08 -8.76315e-08 -1 11.3262 35.4204)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0437 21.8406L31.7285 21.8406L31.7285 4.54253L36.0437 4.54253L36.0437 21.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3589 4.54248L36.0437 4.54248L36.0437 0.237535L40.3589 0.237534L40.3589 4.54248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7526 8.92578L40.4374 8.92578L40.4374 4.62084L44.7526 4.62083L44.7526 8.92578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0678 13.2307L44.7526 13.2307L44.7526 8.92577L49.0678 8.92577L49.0678 13.2307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3831 17.5356L49.0679 17.5356L49.0679 13.2307L53.3831 13.2307L53.3831 17.5356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7768 21.8406L53.4615 21.8406L53.4615 17.5356L57.7768 17.5356L57.7768 21.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.689 21.8406L53.4615 21.8406L53.4615 17.5356L143.689 17.5356L143.689 21.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0437 21.8406L16.2721 21.8406L16.2721 17.5356L36.0437 17.5356L36.0437 21.8406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.689 124.455L16.2721 124.455L16.2721 120.15L143.689 120.15L143.689 124.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.894 111.462L151.579 111.462L151.579 30.5289L155.894 30.5289L155.894 111.462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.185 120.15L142.87 120.15L142.87 115.845L147.185 115.845L147.185 120.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.501 115.767L147.185 115.767L147.185 111.462L151.501 111.462L151.501 115.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.185 26.2236L142.87 26.2236L142.87 21.9187L147.185 21.9187L147.185 26.2236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.501 30.5286L147.185 30.5286L147.185 26.2236L151.501 26.2236L151.501 30.5286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56327 111.462L3.24805 111.462L3.24804 30.5287L7.56326 30.5287L7.56327 111.462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2721 120.15L11.9569 120.15L11.9569 115.845L16.2721 115.845L16.2721 120.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8785 115.767L7.56323 115.767L7.56323 111.462L11.8785 111.462L11.8785 115.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2721 26.2236L11.9569 26.2236L11.9569 21.9187L16.2721 21.9187L16.2721 26.2236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8785 30.5286L7.56323 30.5286L7.56323 26.2236L11.8785 26.2236L11.8785 30.5286Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.69 22.6233L29.3748 22.6233L29.3748 5.32524L33.69 5.32524L33.69 22.6233Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0052 5.32544L33.6899 5.32544L33.6899 1.02049L38.0052 1.02049L38.0052 5.32544Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.399 9.7085L38.0837 9.7085L38.0837 5.40355L42.399 5.40355L42.399 9.7085Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.714 14.0134L42.3988 14.0134L42.3988 9.70848L46.714 9.70848L46.714 14.0134Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0293 18.3184L46.7141 18.3184L46.7141 14.0134L51.0293 14.0134L51.0293 18.3184Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.423 22.6233L51.1078 22.6233L51.1078 18.3183L55.423 18.3183L55.423 22.6233Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.515 22.6233L51.1078 22.6233L51.1078 18.3183L141.515 18.3183L141.515 22.6233Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6899 22.6233L13.9183 22.6233L13.9183 18.3183L33.6899 18.3183L33.6899 22.6233Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.002 125.238L13.9183 125.238L13.9183 120.933L141.002 120.933L141.002 125.238Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.541 112.245L149.225 112.245L149.225 31.3116L153.541 31.3116L153.541 112.245Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.832 120.933L140.516 120.933L140.516 116.628L144.832 116.628L144.832 120.933Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.146 116.549L145.83 116.549L145.83 112.244L150.146 112.244L150.146 116.549Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 27.0063L141.515 27.0063L141.515 22.7014L145.83 22.7014L145.83 27.0063Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.146 31.3113L145.83 31.3113L145.83 27.0063L150.146 27.0063L150.146 31.3113Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20951 112.244L0.894287 112.244L0.89428 31.3114L5.2095 31.3114L5.20951 112.244Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9184 120.933L9.60315 120.933L9.60315 116.628L13.9184 116.628L13.9184 120.933Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52469 116.549L5.20947 116.549L5.20947 112.244L9.52469 112.244L9.52469 116.549Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9184 27.0063L9.60315 27.0063L9.60315 22.7014L13.9184 22.7014L13.9184 27.0063Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52469 31.3113L5.20947 31.3113L5.20947 27.0063L9.52469 27.0063L9.52469 31.3113Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8565 54.1498H23.6343V43.0387H25.8565V40.8165H34.7454V43.0387H36.9676V54.1498H34.7454V56.3721H25.8565V54.1498ZM32.5232 54.1498V43.0387H28.0787V54.1498H32.5232ZM41.4034 49.7054H39.1812V45.261H43.6256V49.7054H48.07V45.261H52.5145V56.3721H48.07V51.9276H41.4034V49.7054ZM54.728 56.3721V45.261H59.1725V49.7054H61.3947V47.4832H63.6169V45.261H68.0614V47.4832H65.8391V49.7054H63.6169V51.9276H65.8391V54.1498H68.0614V56.3721H63.6169V54.1498H61.3947V51.9276H59.1725V56.3721H54.728ZM74.7193 54.1498V56.3721H70.2749V45.261H74.7193V49.7054H76.9416V47.4832H79.1638V45.261H83.6082V56.3721H79.1638V51.9276H76.9416V54.1498H74.7193Z",
    fill: "#444042"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7778 80.4444H30.2222V77.3333H31.7778V80.4444ZM30.2222 72.6667H25.5556V71.1111H30.2222V72.6667ZM25.5556 77.3333H27.1111V78.8889H25.5556V80.4444H24V72.6667H25.5556V77.3333ZM30.2222 82H25.5556V80.4444H30.2222V82ZM30.2222 77.3333H27.1111V75.7778H30.2222V77.3333ZM38.0046 80.4444H36.449V78.8889H38.0046V80.4444ZM41.1157 82H39.5601V74.2222H41.1157V82ZM34.8934 77.3333H36.449V78.8889H34.8934V80.4444H36.449V82H33.3379V74.2222H34.8934V77.3333ZM44.2313 80.4444H42.6758V75.7778H44.2313V80.4444ZM50.4536 75.7778H44.2313V74.2222H50.4536V75.7778ZM50.4536 82H44.2313V80.4444H50.4536V82ZM56.6803 75.7778V82H55.1248V75.7778H52.0137V74.2222H59.7914V75.7778H56.6803ZM67.5738 75.7778H62.9071V74.2222H67.5738V75.7778ZM62.9071 82V85.1111H61.3516V75.7778H62.9071V80.4444H67.5738V82H62.9071ZM69.1293 80.4444H67.5738V75.7778H69.1293V80.4444ZM72.245 80.4444H70.6895V75.7778H72.245V80.4444ZM76.9117 77.3333H75.3561V75.7778H76.9117V74.2222H78.4672V82H76.9117V80.4444H75.3561V78.8889H76.9117V77.3333ZM75.3561 82H72.245V80.4444H75.3561V82ZM75.3561 75.7778H72.245V74.2222H75.3561V75.7778ZM81.5829 77.3333H80.0273V75.7778H81.5829V77.3333ZM80.0273 78.8889H81.5829V82H80.0273V78.8889ZM86.2496 75.7778H81.5829V74.2222H87.8051V82H86.2496V78.8889H81.5829V77.3333H86.2496V75.7778ZM25.5556 97.4444H24V92.7778H25.5556V97.4444ZM30.2222 92.7778H25.5556V91.2222H30.2222V92.7778ZM31.7778 97.4444H30.2222V92.7778H31.7778V97.4444ZM30.2222 99H25.5556V97.4444H30.2222V99ZM41.1157 97.4444H39.5601V94.3333H41.1157V97.4444ZM39.5601 89.6667H34.8934V88.1111H39.5601V89.6667ZM34.8934 94.3333H36.449V95.8889H34.8934V97.4444H33.3379V89.6667H34.8934V94.3333ZM39.5601 99H34.8934V97.4444H39.5601V99ZM39.5601 94.3333H36.449V92.7778H39.5601V94.3333ZM50.4536 95.8889H48.898V91.2222H50.4536V95.8889ZM48.898 95.8889V99H47.3424V97.4444H44.2313V95.8889H48.898ZM44.2313 95.8889H42.6758V91.2222H44.2313V95.8889ZM47.3424 100.556H42.6758V99H47.3424V100.556ZM52.0137 91.2222H53.5692V94.3333H52.0137V91.2222ZM58.2359 94.3333V91.2222H59.7914V99H58.2359V95.8889H53.5692V94.3333H58.2359ZM62.9071 97.4444H61.3516V92.7778H62.9071V97.4444ZM67.5738 94.3333H66.0182V92.7778H67.5738V91.2222H69.1293V99H67.5738V97.4444H66.0182V95.8889H67.5738V94.3333ZM66.0182 99H62.9071V97.4444H66.0182V99ZM66.0182 92.7778H62.9071V91.2222H66.0182V92.7778ZM76.9117 92.7778H72.245V91.2222H76.9117V92.7778ZM72.245 95.8889V97.4444H70.6895V92.7778H72.245V94.3333H76.9117V92.7778H78.4672V95.8889H72.245ZM78.4672 99H72.245V97.4444H78.4672V99ZM84.694 97.4444H83.1385V94.3333H84.694V97.4444ZM86.2496 92.7778V91.2222H87.8051V99H86.2496V94.3333H84.694V92.7778H86.2496ZM81.5829 94.3333V99H80.0273V91.2222H81.5829V92.7778H83.1385V94.3333H81.5829ZM90.9208 97.4444H89.3652V92.7778H90.9208V97.4444ZM95.5875 92.7778H90.9208V91.2222H95.5875V92.7778ZM97.143 97.4444H95.5875V92.7778H97.143V97.4444ZM95.5875 99H90.9208V97.4444H95.5875V99ZM100.259 97.4444H98.7031V92.7778H100.259V97.4444ZM106.481 92.7778H100.259V91.2222H106.481V92.7778ZM106.481 99H100.259V97.4444H106.481V99ZM112.708 92.7778V99H111.152V92.7778H108.041V91.2222H115.819V92.7778H112.708ZM125.157 97.4444H123.601V95.8889H125.157V97.4444ZM118.934 94.3333H123.601V95.8889H118.934V97.4444H123.601V99H117.379V91.2222H118.934V94.3333Z",
    fill: "#1B1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassesDesc);
export default __webpack_public_path__ + "static/media/glassesDesc.9439a93760cc89f4ed31a9c880c443eb.svg";
export { ForwardRef as ReactComponent };